import React from 'react';
import './TrustSection.css';

const POINTS = [
  'Trained & Verified Staff',
  'Eco-Friendly Chemicals',
  'Supervisors & Quality Checks',
  'Flexible Contracts',
  'On-Time Service Guarantee'
];

function TrustSection() {
  return (
    <section className="trust-section animate-on-scroll">
      <div className="container">
        <h2 className="trust-title">Why Companies Trust Us</h2>
        <p className="trust-intro">
          Years of on-ground experience in Ahmedabad, repeat engagements from offices and retail, and clear
          communication when you need replacements or extra staff for events.
        </p>
        <div className="trust-divider" aria-hidden="true" />
        <ul className="trust-list">
          {POINTS.map((point, index) => (
            <li key={index} className="trust-item">
              <span className="trust-check">✓</span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TrustSection;
